import React from 'react';
import { environmentService } from 'src/providers/environment/EnvironmentService';

export interface Permissions {
  permissions: string[];
  setPermissions: React.Dispatch<React.SetStateAction<string[]>>;
  hasPermission: (permission: string) => boolean;
  hasStrictPermission: (permission: string) => boolean;
  isProduction: () => boolean;
}

export function usePermissions(): Permissions {
  const [permissions, setPermissions] = React.useState<string[]>([]);

  const hasPermission = (permission: string) => permissions.includes(permission);
  const hasStrictPermission = (permission: string) => permissions.includes(permission);
  const isProduction = () =>
    environmentService.getEnvironment()?.applicationMode?.toLowerCase() === 'prod';

  return { permissions, setPermissions, hasPermission, hasStrictPermission, isProduction };
}
